module.exports = __webpack_public_path__ + "static/img/left.f48ef9c7.png";